<!--
 * @Author: 张天昊
 * @Date: 2024-05-22 16:35:38
 * @LastEditTime: 2024-06-05 11:02:09
 * @LastEditors: 张天昊
 * @Description: 站点列表切换栏
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/SpotListBar.vue
-->
<script>
import { computed, defineComponent, ref, watch } from 'vue';
import moment from 'moment';
import { useSpotListBarScroll } from '../composables/useSpotListBarScroll';
import { dateStrFormat1 } from '../constants';
import store from '@/store';

export default defineComponent({
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  setup(props, { emit }) {
    const detailInfo = computed(
      () => store.state.itineraryUniversal.detailInfo.value
    );
    const list = computed(() =>
      detailInfo.value
        ? detailInfo.value.itineraryStateMessage.map((item) => {
            const group = item.stateName.split('/');
            if (group.length < 2) {
              group.unshift('云南省');
            }
            let [province, city] = group;
            province = province.trim();
            city = city.trim();
            const start = moment(item.startTime, dateStrFormat1);
            const end = moment(item.endTime, dateStrFormat1);
            const now = moment();
            return {
              city,
              province,
              isActive: now.diff(start) >= 0 && end.diff(now) >= 0
            };
          })
        : []
    );
    const current = computed({
      get() {
        return props.value;
      },
      set(val) {
        emit('input', val);
      }
    });
    const { containerEl, itemEls } = useSpotListBarScroll(current);

    function onItemClick(index) {
      current.value = index;
    }

    function initActive() {
      let idx = -1;
      for (let i = 0; i < list.value.length; i++) {
        if (list.value[i].isActive) {
          idx = i;
          onItemClick(i);
        }
      }
      if (idx < 0) {
        onItemClick(0);
      }
    }

    initActive();

    return {
      list,
      current,
      containerEl,
      itemEls,
      onItemClick
    };
  }
});
</script>

<template>
  <div
    v-if="list.length > 0"
    ref="containerEl"
    class="flex flex-nowrap overflow-x-auto scrollbar-hidden"
  >
    <div
      v-for="(item, index) in list"
      :key="item.city"
      :class="{ active: current === index }"
      ref="itemEls"
      class="flex-shrink-0 bg-board-a rounded-4 px-8 py-10 text-12 leading-17 [&:not(:first-child)]:ml-10"
      @click="onItemClick(index)"
    >
      <div class="flex justify-between">
        <span>站点{{ index + 1 }}</span>
        <span
          v-if="item.isActive"
          class="relative font-semibold text-orange-a with-dot"
          >当前</span
        >
      </div>
      <div class="flex mt-4">
        <span class="font-semibold text-14 mr-11">{{ item.city }}</span>
        <van-tag class="custom-tag" :plain="current !== index">{{
          item.province
        }}</van-tag>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-tag.van-tag {
  font-size: 10px;
  background: transparent;
  color: #9da0a4;
  border-color: #9da0a4;
}
.active {
  border: 1px solid rgb(var(--color-green-b));
  color: rgb(var(--color-green-b));
  background: #f5fcf8;
}
.active .custom-tag.van-tag {
  background: #e8f7ef;
  color: rgb(var(--color-green-primary));
}
.with-dot::before {
  position: absolute;
  content: '';
  width: 3px;
  height: 3px;
  border-radius: 100%;
  background: rgb(var(--color-orange-a));
  top: 50%;
  left: -6px;
  transform: translateY(-50%);
}
</style>
